import { render } from "./OfferTrial.vue?vue&type=template&id=09687211&scoped=true"
import script from "./OfferTrial.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferTrial.vue?vue&type=script&setup=true&lang=js"

import "./OfferTrial.vue?vue&type=style&index=0&id=09687211&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09687211"],['__file',"src/views/paywall/OfferTrial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09687211"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09687211', __exports__)) {
    console.log('reload')
    api.reload('09687211', __exports__)
  }
  
  module.hot.accept("./OfferTrial.vue?vue&type=template&id=09687211&scoped=true", () => {
    console.log('re-render')
    api.rerender('09687211', render)
  })

}


export default __exports__